// Per-brand configuration, read by app.config.js and webpack.config.js
module.exports = {
  // Product name shown in the app bar and the browser tab
  title: 'Download Player',

  // Backend per WEBUI environment
  api: {
    development: 'https://imsapi-local.musicstylingonline.com/api/webplayer/webplayer',
    staging: 'https://staging-api-bridge.musicstylingonline.com/api/webplayer/webplayer',
    production: 'https://api-bridge.musicstylingonline.com/api/webplayer/webplayer'
  },

  // Domain the session cookie is set on; must cover both the player and the API host
  cookieDomain: {
    development: '.musicstylingonline.com',
    staging: '.musicstylingonline.com',
    production: '.musicstylingonline.com'
  },

  // Hostnames the player is served from and the WEBUI environment they run in.
  // Unknown hosts fall back to WEBUI_ENV (default: development).
  hosts: {
    'player-prod.musicstyling.com': 'production',
    'player.musicstyling.com': 'production',
    'player-test.musicstyling.com': 'staging',
    'staging-webplayer.musicstylingonline.com': 'staging',
    'player-dev.musicstyling.com': 'development'
  },

  // See `defaultFeatures` in app.config.js for all options; omitted features are enabled
  features: {
    cubes: false,
    jingles: false,
    rating: false,
    timetable: false,
    stationFilters: false,
    tour: true,
    feedback: false,
    languageSwitcher: true
  }
};
